import React, { useState } from 'react';
import {
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  ListItemSecondaryAction,
  Avatar,
  IconButton,
  Typography,
  Menu,
  MenuItem
} from '@mui/material';
import {
  MoreVert as MoreVertIcon,
  Edit as EditIcon,
  Delete as DeleteIcon
} from '@mui/icons-material';
import ContactDetails from './ContactDetails';
import { contactService, getPhotoUrl } from '../../services/api';

const ContactList = ({ contacts, onEdit, onDelete }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedContact, setSelectedContact] = useState(null);
  const [detailsOpen, setDetailsOpen] = useState(false);

  const handleContactClick = (contact) => {
    setSelectedContact(contact);
    setDetailsOpen(true);
  };

  const handleMenuClick = (event, contact) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setSelectedContact(contact);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedContact(null);
  };

  const handleEdit = () => {
    onEdit(selectedContact);
    handleMenuClose();
  };

  const handleDelete = () => {
    onDelete(selectedContact);
    handleMenuClose();
  };

  const formatPhone = (phone) => {
    if (!phone) return 'Não informado';
    if (phone.match(/^\+55\s\d{2}\s\d{5}-\d{4}$/)) {
      return phone;
    }
    // Se o telefone não estiver formatado, tenta formatá-lo
    const cleaned = phone.replace(/\D/g, '');
    if (cleaned.length === 13) { // +55 + DDD + número
      return `+${cleaned.slice(0,2)} ${cleaned.slice(2,4)} ${cleaned.slice(4,9)}-${cleaned.slice(9)}`;
    }
    return phone;
  };

  return (
    <>
      <List>
        {contacts.map((contact) => (
          <ListItem
            key={contact.id}
            onClick={() => handleContactClick(contact)}
            sx={{ cursor: 'pointer' }}
          >
            <ListItemAvatar>
              <Avatar 
                src={contact.photo ? getPhotoUrl(contact.photo) : ''}
                sx={{ width: 40, height: 40 }}
              >
                {!contact.photo && contact.name.charAt(0).toUpperCase()}
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              primary={contact.name}
              secondary={
                <>
                  {formatPhone(contact.phone1)}
                  {contact.isMainContact && (
                    <Typography
                      component="span"
                      variant="body2"
                      color="primary"
                      sx={{ ml: 1 }}
                    >
                      (Contato Principal)
                    </Typography>
                  )}
                </>
              }
            />
            <ListItemSecondaryAction>
              <IconButton
                edge="end"
                onClick={(e) => handleMenuClick(e, contact)}
              >
                <MoreVertIcon />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
        ))}
      </List>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        <MenuItem onClick={handleEdit}>
          <EditIcon sx={{ mr: 1 }} />
          Editar
        </MenuItem>
        <MenuItem onClick={handleDelete}>
          <DeleteIcon sx={{ mr: 1 }} />
          Excluir
        </MenuItem>
      </Menu>

      <ContactDetails
        open={detailsOpen}
        onClose={() => setDetailsOpen(false)}
        contact={selectedContact}
      />
    </>
  );
};

export default ContactList;
